// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3F93R","title":"Info_title__1Q9WZ","links":"Info_links__nrMxW","link":"Info_link__3F0oj","logo":"Info_logo__1KPA4"};